import { useCallback, useRef } from 'react'

import { useFeatureFlag, useProcurifyIntl } from '@webapp/hooks'
import { ConversationCommandModal } from './components/ConversationCommandModal'
import messages from './messages'
import { useGlobalCommandView } from './useGlobalCommandView'
import { GlobalCommandModal } from '../../components/GlobalCommandModal'
import { GetGlobalSearchResultsPresenter } from '../../features/get-global-search-results/presenters/GetGlobalSearchResultsPresenter'
import { useGlobalSearchHotkey } from '../../hooks/useGlobalSearchHotkey'
import { CatalogItemCartProvider } from '../../providers/CatalogItemCartProvider'
import { ConversationProvider } from '../../providers/ConversationProvider'
import { useGlobalSearch } from '../../providers/GlobalSearchProvider'

export const GlobalCommandView = () => {
  const intl = useProcurifyIntl()
  const DATA_2061_GUIDED_INTAKE_ORDERS = useFeatureFlag(
    'DATA_2061_GUIDED_INTAKE_ORDERS'
  )
  const { isOpen, open, close } = useGlobalSearch()
  const {
    data,
    methods: { startConversation, endConversation },
  } = useGlobalCommandView()
  const searchInputRef = useRef<HTMLInputElement>(null)

  useGlobalSearchHotkey(open)

  const focusSearchInput = () => {
    searchInputRef.current?.focus()
  }

  const handleClose = useCallback(() => {
    endConversation()
    close()
  }, [endConversation, close])

  const conversationQuery = DATA_2061_GUIDED_INTAKE_ORDERS
    ? data.initialQuery
    : null

  if (conversationQuery === null) {
    return (
      <GlobalCommandModal
        isOpen={isOpen}
        onClose={handleClose}
        onEntered={focusSearchInput}
      >
        <GetGlobalSearchResultsPresenter
          key={isOpen ? 'open' : 'closed'}
          inputRef={searchInputRef}
          onClose={handleClose}
          onHandoff={
            DATA_2061_GUIDED_INTAKE_ORDERS ? startConversation : undefined
          }
        />
      </GlobalCommandModal>
    )
  }

  return (
    <ConversationProvider initialQuery={conversationQuery}>
      <CatalogItemCartProvider>
        <ConversationCommandModal
          isOpen={isOpen}
          onClose={handleClose}
          onEntered={focusSearchInput}
          title={intl.formatMessage(messages.conversationTitle)}
        />
      </CatalogItemCartProvider>
    </ConversationProvider>
  )
}
